export default "/images/phone.svg?b2eeedea2da787ba7655a78e8e792148";